module.exports = __webpack_public_path__ + "static/media/image-pet-mobile.6c757931.png";